import { render, staticRenderFns } from "./BeneficiariesInfo.vue?vue&type=template&id=b842b290"
import script from "./BeneficiariesInfo.vue?vue&type=script&lang=js"
export * from "./BeneficiariesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports